import { useState } from 'react';

export default function Testimonials() {
  const testimonials = [
    {
      role: 'ご家族様',
      rating: 5.0,
      comment: 'まごころサービスさんのおかげで、母も私も安心して毎日を過ごせています。スタッフの方々の温かい対応に、いつも感謝しています。本当に家族のように接してくださり、母も心を開いて楽しそうにお話ししています。',
    },
    {
      role: 'ご利用者様',
      rating: 5.0,
      comment: '一人暮らしで不安でしたが、まごころサービスのスタッフさんが定期的に来てくれるので、とても心強いです。話し相手になってくれるだけでなく、生活のサポートもしっかりしてくれます。',
    },
    {
      role: 'ご家族様',
      rating: 5.0,
      comment: '遠方に住んでいるため、父のことが心配でしたが、まごころサービスさんに出会えて本当に良かったです。細やかな気配りと丁寧な対応で、父も喜んでいます。定期的な報告もいただけるので安心です。',
    }
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="testimonials" className="py-20 px-6 bg-gradient-to-b from-amber-50/40 to-white">
      <div className="max-w-4xl mx-auto">
        {/* タイトル */}
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-bold text-gray-800 inline-block relative" style={{ fontFamily: "'Zen Maru Gothic', sans-serif" }}>
            <span className="text-orange-300 mr-3">「</span>
            お客様の声
            <span className="text-orange-300 ml-3">」</span>
          </h3>
        </div>

        {/* レビューカード */}
        <div className="relative bg-white rounded-3xl p-10 md:p-14 shadow-lg">
          {/* 評価バッジ */}
          <div className="inline-flex items-center gap-2 bg-amber-900 text-white px-4 py-2 rounded-full mb-6">
            <i className="ri-star-fill text-yellow-300"></i>
            <span className="font-bold text-sm">{testimonials[currentIndex].rating}</span>
          </div>

          {/* レビュー本文 */}
          <blockquote className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            {testimonials[currentIndex].comment}
          </blockquote>

          {/* 利用者情報（役割のみ） */}
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-full flex-shrink-0">
              <i className="ri-user-line text-amber-900 text-sm"></i>
            </div>
            <p className="text-sm text-gray-500 font-light" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
              {testimonials[currentIndex].role}
            </p>
          </div>

          {/* ナビゲーションボタン */}
          <div className="flex items-center gap-3 justify-end">
            <button 
              onClick={handlePrev}
              className="w-12 h-12 flex items-center justify-center border-2 border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
              aria-label="前のレビュー"
            >
              <i className="ri-arrow-left-line text-xl text-gray-600"></i>
            </button>
            <button 
              onClick={handleNext}
              className="w-12 h-12 flex items-center justify-center bg-amber-900 rounded-lg hover:bg-amber-800 transition-colors cursor-pointer"
              aria-label="次のレビュー"
            >
              <i className="ri-arrow-right-line text-xl text-white"></i>
            </button>
          </div>
        </div>

        {/* インジケーター */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentIndex(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentIndex ? 'bg-amber-900 w-8' : 'bg-gray-300'
              }`}
              aria-label={`レビュー ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
